import { Component, OnInit, signal } from '@angular/core';
import {
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser,DOCUMENT, CommonModule } from '@angular/common';
import { CatalogService } from '../../modules/catalog/catalog.service';
import { Header } from "../../shared/header/header";
import { BestPackage } from "../catalog/best-package/best-package";
import { WhyChooseYouprice } from "./why-choose-youprice/why-choose-youprice";
import { ReviewsComponent } from "./review/review";
import { SmallFaq } from "../../shared/small-faq/small-faq";
import { Footer } from "../../shared/footer/footer";

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    Header,
    BestPackage,
    WhyChooseYouprice,
    ReviewsComponent,
    SmallFaq,
    Footer,
    CommonModule
  ],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private catalogService: CatalogService
  ) {}
  allProducts = signal<Product[]>([]);
  momentProducts = signal<Product[]>([]);
  forfaits = signal<Record<string, Product[]>>({});
  operators = ['orange', 'sfr', 'bouygues'];
  public momentProductsList: any[] = [];
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({ 
        event: 'virtual_page_view',
        ecommerce: null,
        page_location: 'https://www.youprice.fr/',
        page_path: '/',
        content_group: 'HP',
        user_id: ''
      });
      (window as any).dataLayer.push({ 
        zone: 'homepage'
      });
      this.getActiveProduct();
    }
    
  }
  getActiveProduct() {
    this.catalogService.GetActiveProductForV2().subscribe({
      next: (data) => {
        const flatProducts = Object.values(data).flat() as Product[];
        this.allProducts.set(flatProducts);
        this.momentProductsList = flatProducts;
        this.filterForfaits();
      },
      error: (error) => {
        // console.error('Error fetching forfaits:', error);
      }
    });
  }

  filterForfaits(): void {
    const products = this.allProducts();
    if (!products.length) {
      console.warn('No products to filter');
      return;
    }
    const grouped = products.reduce((acc: Record<string, Product[]>, product: Product) => {
      if (!acc[product.operators]) {
        acc[product.operators] = [];
      }
      // const lastDashIndex = product.urlName.lastIndexOf('-');
      // if (lastDashIndex > 0) {
      //   product.urlName = product.urlName.substring(0, lastDashIndex);
      // }
      acc[product.operators].push(product);
      return acc;
    }, {});
    Object.keys(grouped).forEach(operator => {
      grouped[operator].sort((a, b) => (a.maxVolume ?? 0) - (b.maxVolume ?? 0));
    });
    this.forfaits.set(grouped);
    const moments = products
      .filter(product => product.isMomenProduct === true)
      .sort((a, b) => (b.maxVolume ?? 0) - (a.maxVolume ?? 0));
    this.momentProducts.set(moments);
  }
}
export interface Product {
  operators: string;
  isMomenProduct: boolean;
  prix?: string;
  gigas?: string;
  reseau?: string;
  urlName: string;
  id?: string;
  classification?: string;
  promo?: boolean;
  simPrice?:number;
  maxVolume:number;
  maxTarif?:number;
  fonctionalites?: string;
  fonctionalitesList?: any;
  forfaitRoamingEuropVolume?: string;
  dateEndValidation?: Date;
}